import { Block } from '../types/Block';

// ─────────────────────────────────────────────────────────────────────────────
// État initial du chiffrage : 2 lots, dont Lot 2 pré-rempli (démo paysagisme)
// ─────────────────────────────────────────────────────────────────────────────
// Lot 1 : vide (à compléter par l'utilisateur).
// Lot 2 : 7 prestations « Toiture végétalisée Hôtel Mercure », rattachées via
//         parentId='lot-2'. Les `matchedItemId` pointent vers les ouvrages
//         (ids 18-24) de la bibliothèque (1-bibliotheque-prix/data/ServicesData.ts).
// L'ensemble sert aussi à l'animation d'import (cf. ChiffrageContainer).
export const defaultBlocks: Record<string, Block> = {
  'lot-1': {
    id: 'lot-1',
    parentId: undefined,
    order: 0,
    level: 0,
    blockType: 'titre',
    children: [],
    content: { titre: 'Lot 1' }
  },
  'lot-2': {
    id: 'lot-2',
    parentId: undefined,
    order: 1,
    level: 0,
    blockType: 'titre',
    children: [
      'prestation-jardinieres',
      'prestation-drainage',
      'prestation-nappe-filtrante',
      'prestation-substrat',
      'prestation-sujets',
      'prestation-graminees',
      'prestation-pots',
    ],
    content: { titre: 'Lot 2 — Toiture végétalisée Hôtel Mercure' }
  },

  'prestation-jardinieres': {
    id: 'prestation-jardinieres',
    parentId: 'lot-2',
    order: 0,
    level: 1,
    blockType: 'prestation',
    children: [],
    content: {
      titre: 'Jardinières métalliques',
      intitule: 'Jardinières métalliques',
      categorie: 'Aménagement extérieur > Mobilier',
      unite: 'u',
      prixUnitaire: '1290',
      quantite: '12',
      prixTotal: '15480',
      chantier: 'Hôtel Mercure',
      fournisseur: 'Atelier So Green',
      matchedItemId: '18',
      matchedItemType: 'prestation'
    }
  },

  'prestation-drainage': {
    id: 'prestation-drainage',
    parentId: 'lot-2',
    order: 1,
    level: 1,
    blockType: 'prestation',
    children: [],
    content: {
      titre: 'Drainage en bille d\'argile',
      intitule: 'Drainage en bille d\'argile',
      categorie: 'Aménagement extérieur > Substrat',
      unite: 'm²',
      prixUnitaire: '14.50',
      quantite: '180',
      prixTotal: '2610',
      chantier: 'Hôtel Mercure',
      fournisseur: 'Laterlite',
      matchedItemId: '19',
      matchedItemType: 'prestation'
    }
  },

  'prestation-nappe-filtrante': {
    id: 'prestation-nappe-filtrante',
    parentId: 'lot-2',
    order: 2,
    level: 1,
    blockType: 'prestation',
    children: [],
    content: {
      titre: 'Nappe filtrante',
      intitule: 'Nappe filtrante',
      categorie: 'Aménagement extérieur > Substrat',
      unite: 'm²',
      prixUnitaire: '4.20',
      quantite: '180',
      prixTotal: '756',
      chantier: 'Hôtel Mercure',
      fournisseur: 'Soprema',
      matchedItemId: '20',
      matchedItemType: 'prestation'
    }
  },

  'prestation-substrat': {
    id: 'prestation-substrat',
    parentId: 'lot-2',
    order: 3,
    level: 1,
    blockType: 'prestation',
    children: [],
    content: {
      titre: 'Substrat intensif allégé (ép. 65cm)',
      intitule: 'Substrat intensif allégé (ép. 65cm)',
      categorie: 'Aménagement extérieur > Substrat',
      unite: 'm³',
      prixUnitaire: '182',
      quantite: '117',
      prixTotal: '21294',
      chantier: 'Hôtel Mercure',
      fournisseur: 'Florentaise',
      matchedItemId: '21',
      matchedItemType: 'prestation'
    }
  },

  'prestation-sujets': {
    id: 'prestation-sujets',
    parentId: 'lot-2',
    order: 4,
    level: 1,
    blockType: 'prestation',
    children: [],
    content: {
      titre: 'Sujets structurants (Arbustes persistants)',
      intitule: 'Sujets structurants (Arbustes persistants)',
      categorie: 'Aménagement extérieur > Végétaux',
      unite: 'u',
      prixUnitaire: '32',
      quantite: '45',
      prixTotal: '1440',
      chantier: 'Hôtel Mercure',
      fournisseur: 'Pépinières Lemonnier',
      matchedItemId: '22',
      matchedItemType: 'prestation'
    }
  },

  'prestation-graminees': {
    id: 'prestation-graminees',
    parentId: 'lot-2',
    order: 5,
    level: 1,
    blockType: 'prestation',
    children: [],
    content: {
      titre: 'Graminées et vivaces de toiture (6u/m2)',
      intitule: 'Graminées et vivaces de toiture (6u/m2)',
      categorie: 'Aménagement extérieur > Végétaux',
      unite: 'u',
      prixUnitaire: '5.20',
      quantite: '1080',
      prixTotal: '5616',
      chantier: 'Hôtel Mercure',
      fournisseur: 'Pépinières Lemonnier',
      matchedItemId: '23',
      matchedItemType: 'prestation'
    }
  },

  'prestation-pots': {
    id: 'prestation-pots',
    parentId: 'lot-2',
    order: 6,
    level: 1,
    blockType: 'prestation',
    children: [],
    content: {
      titre: 'Pots compris drainage substrat plante paillage',
      intitule: 'Pots compris drainage substrat plante paillage',
      categorie: 'Aménagement extérieur > Mobilier',
      unite: 'u',
      prixUnitaire: '510',
      quantite: '20',
      prixTotal: '10200',
      chantier: 'Hôtel Mercure',
      fournisseur: 'Image\'In Jardin',
      matchedItemId: '24',
      matchedItemType: 'prestation'
    }
  }
};

export const defaultRootBlocks: string[] = ['lot-1', 'lot-2'];

export const defaultBlockEditorState = {
  blocks: defaultBlocks,
  rootBlocks: defaultRootBlocks,
  selectedBlockId: undefined,
  editingBlockId: undefined
};
